import { Injectable } from '@angular/core';
import { HttpService } from '@api/http';
import { Observable } from 'rxjs';
import { ImportToFusionDto } from './dtos/import-to-fusion-request.dto';
import { ImportToFusionResponseDto } from './dtos/import-to-fusion-response.dto';
import { UrlPathsEnum } from '../external-transfer/models/url-paths-enum';

@Injectable({
	providedIn: 'root'
})
export class ImportToFusionApiService {
	public constructor(private httpService: HttpService) {}

	public importToFusion$(
		connectionId: string,
		requestPayload: ImportToFusionDto
	): Observable<ImportToFusionResponseDto> {
		return this.httpService.post(connectionId, UrlPathsEnum.import, requestPayload);
	}
}
